// ReviewBar.styles.ts
import { css } from '@emotion/css';

export const styles = {
  meetsTheBarContainer: css({
    display: 'inline-block',
    width: '100%',
  }),

  reviewBarTitle: css({
    marginTop: '20px',
    marginBottom: '20px',
    color: '#02080e',
  }),

  radioButtonContainer: css({
    width: '90%',
    display: 'inline-flex',
    marginBottom: '40px',
  }),

  radioButtonRow: css({
    width: '90%',
    display: 'inline-flex',
    marginLeft: '50px',
    marginTop: '20px',
  }),

  expertColumn: css({
    float: 'left',
    width: '30%',
    display: 'block',
  }),

  intermediateColumn: css({
    float: 'left',
    width: '30%',
    display: 'block',
  }),

  noviceColumn: css({
    float: 'left',
    width: '30%',
    display: 'block',
  }),

  iconDescriptor: css({
    fontSize: '14px',
  }),

  descriptorListItem: css({
    color: '#5f6b7a',
    fontSize: '12px',
    lineHeight: '16px',
  }),

  descriptorLeft: css({
    marginLeft: '85px',
    marginTop: 0,
  }),

  descriptorRight: css({
    marginLeft: '80px',
    marginTop: 0,
    maxWidth: '260px',
  }),

  textAreaContainer: css({
    width: '90%',
    margin: 'auto',
    '& > *': {
      width: '90%',
      margin: 'auto',
    },
  }),

  yesCheckGreen: css({
    color: 'green',
  }),

  noXRed: css({
    color: 'red',
  }),
};
